import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/API";

export interface inventorySalesDataInterface {
  ISBN: string,
  DATE: string,
  inv_DATE: string,
  Total_Indy_Usable:number,
  Total_Indy_Other:number,
  Total_Indy_Alloc:number,
  Total_Reserved:number,
  Total_BO_Units:number,
  Total_UK_USABLE:number,
  Total_AU_USABLE:number
}

interface TitleListInventoryState {
  data: inventorySalesDataInterface;
  status: string;
  statusCode: number;
  error: string | null;
  isLoading: boolean;
}
const initialState: TitleListInventoryState = {
  data: {
    ISBN:"",
    DATE:"",
    inv_DATE:"",
    Total_Indy_Usable:0,
    Total_Indy_Other:0,
    Total_Indy_Alloc:0,
    Total_Reserved:0,
    Total_BO_Units:0,
    Total_UK_USABLE:0,
    Total_AU_USABLE:0,
  },
  status: "",
  error: null,
  statusCode: 0,
  isLoading: false,
};

export const FetchTitleListInventorySalesRecord = createAsyncThunk(
  "FetchTitleListInventorySalesRecord",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axios.post(API.FetchInventorySales,data);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response);
    }
  }
);

const TitleListInventorySlice = createSlice({
  name: "TitleListInventoryData",
  initialState,
  reducers: {
    clearInventorySales: (state) => {
          state.data = initialState.data;
        },
  },
  extraReducers(builder) {
    builder
      .addCase(FetchTitleListInventorySalesRecord.pending, (state) => {
        state.isLoading = true;
        state.status = "Loading";
      })
      .addCase(FetchTitleListInventorySalesRecord.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = "success";
        state.data = action.payload.data;
      })
      .addCase(FetchTitleListInventorySalesRecord.rejected, (state) => {
        state.isLoading = false;
        state.status = "Failed";
        state.error = "Error";
      });
  },
});

export const {clearInventorySales
} = TitleListInventorySlice.actions;
export default TitleListInventorySlice.reducer;
